import React from 'react';
import { Badge, Button, Group, Label, Stack } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { getOpenBankingAccountNumber } from '~/helpers/shared.helper';
import { useGetBankAccountsQuery } from '~/store/apis/endpoints/onboardingApi/onboarding.api';
import { RadioGroup } from '~/components/shared/RadioGroup/RadioGroup';

interface OpenBankingAccountListProps {
  handleAccountSelected: (value: string) => void;
  handleAddNewAccount: () => void;
}

const OpenBankingAccountList = ({
  handleAccountSelected,
  handleAddNewAccount,
}: OpenBankingAccountListProps) => {
  const {
    loanOffer: {
      overview,
      form: { openBankingAccount },
    },
  } = useSelector((state: RootState) => state);

  const { data: openBankingAccounts = [] } = useGetBankAccountsQuery(
    { clientId: overview.clientId },
    {
      skip: !overview.clientId,
    }
  );

  const translate = useTranslate();

  const selectedAccountNumber = openBankingAccount
    ? getOpenBankingAccountNumber(openBankingAccount)
    : '';

  const accountOptions = openBankingAccounts.map((bankAccount) => {
    const accountNumber = getOpenBankingAccountNumber(bankAccount);

    return {
      value: accountNumber,
      label: bankAccount.details ?? accountNumber,
      description: bankAccount.details ? accountNumber : undefined,
      rightSection: bankAccount.isNewlyAdded && (
        <Badge color="Main/Primary/400" size="sm">
          {translate('OnboardingOffer.BankConnectionNewAccountBadge')}
        </Badge>
      ),
    };
  });

  return (
    <Stack spacing={'md'}>
      <Label size="lg" data-record>
        {translate('OnboardingOffer.PreviouslyVerifiedAccountsLabel')}
      </Label>
      <RadioGroup
        layout="stacked"
        options={accountOptions}
        value={selectedAccountNumber}
        onChange={handleAccountSelected}
      />
      <Group justify="flex-end">
        <Button
          variant="secondary"
          rightIcon="east"
          size="md"
          compact
          onClick={handleAddNewAccount}
        >
          <span data-record>
            {translate('OnboardingOffer.AddDifferentAccountButtonText')}
          </span>
        </Button>
      </Group>
    </Stack>
  );
};

export default OpenBankingAccountList;
